import React from 'react';
export function HeroSection() {
  return <section className="w-full bg-white py-16 md:py-24 px-4" data-id="element-137">
      <div className="max-w-7xl mx-auto" data-id="element-138">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-139">
          {/* Left: Headline + Media Logos + CTA */}
          <div data-id="element-140">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brand-black leading-tight mb-6" data-id="element-141">
              5 Reasons Men Are Switching to CrownControl™ for Hair Regrowth
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mb-8 leading-relaxed" data-id="element-142">
              Most hair loss solutions are outdated, invasive, or mess with your
              hormones. Red light therapy is the modern, science-backed
              alternative that works with your body—not against it.
            </p>

            {/* Media Logos Row */}
            <div className="flex flex-wrap items-center gap-4 mb-10" data-id="element-143">
              <span className="text-sm text-gray-500 font-medium" data-id="element-144">
                AS SEEN IN:
              </span>
              <div className="flex flex-wrap items-center gap-6" data-id="element-145">
                <span className="px-4 py-2 bg-gray-100 rounded text-gray-700 font-semibold text-sm" data-id="element-146">
                  Forbes
                </span>
                <span className="px-4 py-2 bg-gray-100 rounded text-gray-700 font-semibold text-sm" data-id="element-147">
                  Men's Health
                </span>
                <span className="px-4 py-2 bg-gray-100 rounded text-gray-700 font-semibold text-sm" data-id="element-148">
                  GQ
                </span>
              </div>
            </div>

            {/* CTA Button */}
            <a href="https://offer.crowncontrol.shop/" className="inline-block bg-brand-red text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-red-700 transition-colors shadow-lg" aria-label="Get CrownControl" data-id="element-149">
              Learn More
            </a>
          </div>

          {/* Right: Before/After Comparison */}
          <div className="relative" data-id="element-150">
            <img src="https://cdn.magicpatterns.com/uploads/1jMD8wvBtVYhdCSXM654kg/Untitled_design_(1).svg" alt="Before and after hair regrowth results showing visible improvement after 6 months of using CrownControl" className="w-full h-auto rounded-2xl shadow-xl" data-id="element-151" />
          </div>
        </div>
      </div>

      {/* Horizontal Banner Separator */}
      <div className="max-w-7xl mx-auto mt-16 md:mt-24" data-id="element-152">
        <div className="w-full h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent" data-id="element-153"></div>
      </div>
    </section>;
}